import { CheckCircle } from "@phosphor-icons/react";
import { KidAvatar } from "@/components/KidAvatar";

export function StudentPicker({ students, value, onChange, savedIds, variant }) {
  const saved = savedIds instanceof Set ? savedIds : new Set(savedIds || []);
  const hafalan = variant === "hafalan";
  const laporan = variant === "laporan";
  return (
    <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1 mb-4">
      {students.map((s) => {
        const done = saved.has(s.id);
        const active = value === s.id;
        let cls = "bg-white border-stone-200";
        let txt = "text-stone-500";
        if (active) { cls = "bg-primary/10 border-primary"; txt = "text-primary"; }
        else if (hafalan) {
          if (done) { cls = "bg-blue-50 border-blue-400"; txt = "text-blue-700"; }
          else { cls = "bg-red-50 border-red-300"; txt = "text-red-600"; }
        } else if (laporan) {
          if (done) { cls = "bg-green-50 border-green-400"; txt = "text-green-700"; }
          else { cls = "bg-red-50 border-red-300"; txt = "text-red-600"; }
        } else if (done) { cls = "bg-green-50 border-green-300"; txt = "text-green-700"; }
        return (
          <button
            key={s.id}
            data-testid={`pick-student-${s.id}`}
            onClick={() => onChange(s.id)}
            className={`shrink-0 w-[84px] flex flex-col items-center gap-1 px-2 py-2 rounded-2xl border transition-colors relative ${cls}`}
          >
            {done && <CheckCircle size={16} weight="fill" className={`absolute top-1 right-1 ${hafalan && !active ? "text-blue-500" : "text-green-500"}`} />}
            <KidAvatar gender={s.gender} size={40} src={s.avatar} />
            <span className={`text-[11px] font-semibold leading-tight text-center line-clamp-3 min-h-[39px] ${txt}`}>{s.name}</span>
          </button>
        );
      })}
    </div>
  );
}
